import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { dashboardBackgroundScriptsLayout } from '@atlassian/jira-background-scripts-layout/src/index.tsx';
import { DASHBOARD } from '@atlassian/jira-capabilities/src/constants.tsx';
import { NORMAL_EARLY_ASSET_STRATEGY } from '@atlassian/jira-common-constants/src/ssr-early-assets.tsx';
import { globalLayout } from '@atlassian/jira-global-layout/src/index.tsx';
import { MENU_ID, SIDEBAR_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/index.tsx';
import { composeLayouts } from '@atlassian/jira-route-layout/src/GlobalComponent.tsx';
import { getNavigationResources } from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import { dashboardViewRoute } from '@atlassian/jira-router-routes-dashboard-routes/src/dashboardViewRoute.tsx';
import type { Route } from '@atlassian/react-resource-router/src/common/types.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { dashboardViewEntryPoint } from '@atlassian/jira-dashboard-view/entrypoint.tsx';
import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { nav4SidebarContentCoreEntryPoint } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-content-core/entrypoint.tsx';
import { nav4DashboardsContentEntryPoint } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-content-dashboards/src/ui/dashboards/default/async-content/entrypoint.tsx';
import { DashboardViewPage, dashboardResources, LazyDashboardView } from './ui/index.tsx';

export const dashboardViewRouteEntry: Route = createEntry(dashboardViewRoute, () => ({
	group: 'dashboard',
	component: DashboardViewPage,
	entryPoint: pageEntryPoint,
	layout: composeLayouts(globalLayout, dashboardBackgroundScriptsLayout),
	navigation: {
		menuId: MENU_ID.DASHBOARDS,
		sidebarId: SIDEBAR_ID.CONTENT, // Nav4
	},
	resources: [...getNavigationResources(), ...dashboardResources()],
	forPaint: [LazyAtlassianNavigation, LazyDashboardView],
	meta: {
		capability: DASHBOARD,
	},
	earlyAssets: NORMAL_EARLY_ASSET_STRATEGY,
	ufoName: 'dashboard',
}));

const pageEPConfigOld = createPageEntryPoint({
	main: dashboardViewEntryPoint,
	topNavigationMenuId: MENU_ID.DASHBOARDS,
	leftSidebar: {
		sidebar: nav4SidebarContentCoreEntryPoint,
		entryPoints: {},
		// Temporary, until we can remove the *Landing components from the Nav4 sidebar
		isDashboardsExpanded: true,
	},
});

const pageEPConfigNew = createPageEntryPoint({
	main: dashboardViewEntryPoint,
	topNavigationMenuId: MENU_ID.DASHBOARDS,
	leftSidebar: {
		sidebar: nav4SidebarContentCoreEntryPoint,
		entryPoints: { dashboards: { entryPoint: nav4DashboardsContentEntryPoint } },
		// Temporary, until we can remove the *Landing components from the Nav4 sidebar
		isDashboardsExpanded: true,
	},
});

function pageEntryPoint() {
	if (fg('blu-6923-dashboard-entry-points')) {
		if (fg('blu-6923-nav4-dashboard-ep-support')) {
			return pageEPConfigNew;
		}
		return pageEPConfigOld;
	}
	return undefined;
}
